module.exports = __webpack_public_path__ + "static/img/tech-icon.b6704dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/tech-icon.png
// module id = Cw8A
// module chunks = 0